<div class="side-bar">
    <div class="container">
        <div class="row" cdkDropListGroup>
            <div class="example-container">
                <div cdkDropList [cdkDropListData]="tempColumns" class="example-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="example-box row justify-content-between" *ngFor="let item of tempColumns" cdkDrag>
                        <div class="col-8 text-content">
                            <input type="checkbox" [checked]="item.IsVisible"
                                (change)="OnItemVisibilityChanges(item ,$event)" />
                            <span class="px-1">{{item.DisplayName | translate}}</span>
                        </div>
                        <div class="col-2"><svg width="20px" height="20px" viewBox="0 -6 20 20" id="meteor-icon-kit__regular-grip-lines" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 8C0.44772 8 0 7.5523 0 7C0 6.4477 0.44772 6 1 6H19C19.5523 6 20 6.4477 20 7C20 7.5523 19.5523 8 19 8H1zM1 2C0.44772 2 0 1.55228 0 1C0 0.44772 0.44772 0 1 0H19C19.5523 0 20 0.44772 20 1C20 1.55228 19.5523 2 19 2H1z" fill="#000"/></svg></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>